module.exports = "/static-assets/_next/static/images/img-249f4e1ab5-567bf1616d68d61067f3eaa822bd9768.webp";